import React, { Component } from 'react';

import CardMedia from '@material-ui/core/CardMedia';

import logo from '../images/404.png';

// eslint-disable-next-line
import style from './_styles.css';

class Index extends Component {
    render() {
        return (
            <div className="fullscreen center bg_dark_grey_blue notFound">
                <div className="fullWidth">
                    <div className={'numberNotFound'}>
                        <span className="page_error_number_text c_white">4</span>
                        <CardMedia className={'imgNotFound'} image={logo} title="iFlares" />
                        <span className="page_error_number_text c_white">4</span>
                    </div>
                    <h3 className="barlowsemicondensed_bold c_white uppercase">page not found</h3>
                    <p className={'pNotFound'}>
                        We are sorry but the page you are looking for does not exist.
                    </p>
                </div>
            </div>
        );
    }
}

export default Index;



// WEBPACK FOOTER //
// ./src/pages/NotFound.js